import type { ReactElement } from 'react'

import { IR_GOVERNANCE_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

export const GovernancePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Corporate Governance"
        subTitleText="コーポレート・ガバナンス"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_GOVERNANCE_ROUTE.subdirectories.map(
          ({ name, path, imagePath, ...rest }) => (
            <LinkCard
              title={name}
              link={path}
              imgPath={imagePath}
              key={path}
              {...rest}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}

GovernancePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: 'コーポレート・ガバナンス', path: '' },
  ]
  return (
    <>
      <Head
        title="コーポレート・ガバナンス"
        description="トライアルホールディングスのコーポレート・ガバナンスを掲載しています。"
        ogp={{ url: 'ir/governance' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
